export enum SignUpFieldName {
  Email = 'Email',
  CreatePassword = 'Create Password',
  ConfirmPassword = 'Confirm Password',
}
